export const colors = {
  black: "#000",
  dark: "#112340",
  darkGray300: "#AAB0BB",
  lightGray400: "#DEE6F0",
  subtitle: "#959A9F",
  error: "#FE5050",
  grey: "#7D8797",
  lightGrey: "#D3DBE5",
  info: "#59B4FF",
  light: "#F5F7FA",
  primary: "#1FD4AF",
  secondary: "#FF9D37",
  white: "#FFF",
  borderColor: "#D4DBE5",
};
